import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./languageSlice";
import chatBotReducer from "./chatBotSlice";

export const store = configureStore({
  reducer: {
    language: languageReducer,
    chatBot: chatBotReducer,
  },
});
